import styled from '@emotion/styled'

const BottomButton = () => {
	return (
		<Block>
			<div>
				<SubmitButton type="submit" value="입점하기" />
			</div>
		</Block>
	)
}

const Block = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	padding: 3rem 12.5rem 3rem;

	& > div {
		width: 103rem;
		background: inherit;
	}
`

const SubmitButton = styled.input`
	background: #ffcf19;
	border: none;
	color: #363644;
	font-size: 1.4rem;
	line-height: 2.4rem;
	font-weight: 600;
	text-align: center;
	height: 4rem;
	padding: 0 2rem;
	cursor: pointer;
`

export default BottomButton
